var Segment = {
    COUNTRY: {
        TR: 'TR'
    },
    APPLICATION: 'CicekSepeti',
    LIVE_CHAT: 'Live Chat'
};
export var SegmentEvents = {
    SIGNED_UP: 'Signed Up',
    SIGNED_IN: 'Signed In',
    SIGNED_UPDATE: 'Signed Update'
};
export default Segment;
